import '../pages/tabs/Tabs.css';
import React from "react";
import noodles from '../assets/constants/noodles.js';
import medals from '../assets/constants/medals.js';

function NoodleList(props)  {

    function compare( a, b ) {
        if (props.selectedSort === "default" ) {
            if ( a.number < b.number ){
                return -1;
              }
              if ( a.number > b.number ){
                return 1;
              }
              return 0;
        }
        //  else if (props.selectedSort === "flavor" ) {
        //     if ( a.country < b.country ){
        //         return -1;
        //       }
        //       if ( a.country > b.country ){
        //         return 1;
        //       }
        //       return 0;
        // }
        else if (props.selectedSort === "country" ) {
            if ( a.country < b.country ){
                return -1;
              }
              if ( a.country > b.country ){
                return 1;
              }
              return 0;
        }
        else if (props.selectedSort === "spice" ) {
            if ( a.spice < b.spice ){
                return -1;
              }
              if ( a.spice > b.spice ){
                return 1;
              }
              return 0;
        } else {
            return 0
        }
        
      }

    let w = window.innerWidth;
    return (
        <div className="noodleScrollContainer">
        {noodles.sort(compare).map((noodle, index) => (
                  <div className="noodleObject" key={index} onClick={() => props.setActiveNoodle(noodle)}>
                      <div key={index}>
                        <img loading="lazy" className="noodleImage" width={noodle.mobileWidth*(w/423)} height={noodle.mobileHeight*(w/423)} src={noodle.href} alt={"drawing of " + noodle.name}/>
                        { props.userProfile.favoriteNoodles.indexOf(noodle.number) >=0 && 
                            <img loading="lazy" className="noodleImageMedal" src={medals[props.userProfile.favoriteNoodles.indexOf(noodle.number)].src} alt={medals[props.userProfile.favoriteNoodles.indexOf(noodle.number)].alt}/>
                        }
                      </div>
                  </div>
                  ))}
        </div>
    )
}

export default NoodleList;